// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-container {
  width: 100%;
  height: var(--input-element-height);
}

.select-control,
.select-control-focus {
  cursor: pointer !important;
  border-radius: calc(var(--input-element-height) / 2) !important;
  border-color: var(--border-color) !important;
  height: 100%;
  min-width: 200px;
}

.select-control-focus {
  box-shadow: 0px 0px 12px -1px var(--border-color) !important;
}

.select-control input,
.select-control-focus input {
  height: unset;
  border-radius: unset;
  box-shadow: unset;
}

.select-indicator-separator {
  background-color: var(--border-color) !important;
}

.select-indicator-container > div {
  color: var(--border-color);

  &:hover {
    color: var(--text-color);
  }
}

.select-value-container {
  padding-left: var(--font-size-l) !important;
  font-size: var(--font-size-l);
  height: 100%;
}

.select-menu {
  border-radius: var(--dialog-border-radius) !important;
  z-index: 9999 !important;
}

.select-menu-floating {
  position: fixed !important;
  top: unset !important;
  width: unset !important;
  display: none !important;
}

.select-menu-list {
  padding: var(--scrollbar-padding) !important;
}

.select-option,
.select-option-focus,
.select-option-selected {
  border-radius: calc(var(--dialog-border-radius) / 1.5) !important;
}

.select-option-selected {
  background-color: var(--selection-background-color) !important;
  color: var(--text-contrast-color) !important;

  > * {
    color: var(--text-contrast-color) !important;
  }

  &:hover {
    background-color: var(--selection-hover-color) !important;
  }
}

.select-option-selected .icon-button {
  color: var(--text-contrast-color) !important;
}

.select-option-focus {
  background-color: var(--item-hover-color) !important;
}

.select-single-value {
  color: var(--text-color) !important;
}

.select-menu-portal {
  z-index: 99999 !important;
  font-family: var(--font-family) !important;
}
`, "",{"version":3,"sources":["webpack://./src/ui/style/elements/select-element.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;;EAEE,0BAA0B;EAC1B,+DAA+D;EAC/D,4CAA4C;EAC5C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;EAEE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;;EAE1B;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;;EAGE,iEAAiE;AACnE;;AAEA;EACE,8DAA8D;EAC9D,4CAA4C;;EAE5C;IACE,4CAA4C;EAC9C;;EAEA;IACE,yDAAyD;EAC3D;AACF;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C","sourcesContent":[".select-container {\n  width: 100%;\n  height: var(--input-element-height);\n}\n\n.select-control,\n.select-control-focus {\n  cursor: pointer !important;\n  border-radius: calc(var(--input-element-height) / 2) !important;\n  border-color: var(--border-color) !important;\n  height: 100%;\n  min-width: 200px;\n}\n\n.select-control-focus {\n  box-shadow: 0px 0px 12px -1px var(--border-color) !important;\n}\n\n.select-control input,\n.select-control-focus input {\n  height: unset;\n  border-radius: unset;\n  box-shadow: unset;\n}\n\n.select-indicator-separator {\n  background-color: var(--border-color) !important;\n}\n\n.select-indicator-container > div {\n  color: var(--border-color);\n\n  &:hover {\n    color: var(--text-color);\n  }\n}\n\n.select-value-container {\n  padding-left: var(--font-size-l) !important;\n  font-size: var(--font-size-l);\n  height: 100%;\n}\n\n.select-menu {\n  border-radius: var(--dialog-border-radius) !important;\n  z-index: 9999 !important;\n}\n\n.select-menu-floating {\n  position: fixed !important;\n  top: unset !important;\n  width: unset !important;\n  display: none !important;\n}\n\n.select-menu-list {\n  padding: var(--scrollbar-padding) !important;\n}\n\n.select-option,\n.select-option-focus,\n.select-option-selected {\n  border-radius: calc(var(--dialog-border-radius) / 1.5) !important;\n}\n\n.select-option-selected {\n  background-color: var(--selection-background-color) !important;\n  color: var(--text-contrast-color) !important;\n\n  > * {\n    color: var(--text-contrast-color) !important;\n  }\n\n  &:hover {\n    background-color: var(--selection-hover-color) !important;\n  }\n}\n\n.select-option-selected .icon-button {\n  color: var(--text-contrast-color) !important;\n}\n\n.select-option-focus {\n  background-color: var(--item-hover-color) !important;\n}\n\n.select-single-value {\n  color: var(--text-color) !important;\n}\n\n.select-menu-portal {\n  z-index: 99999 !important;\n  font-family: var(--font-family) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
